<template>
  <div class="soar-container flex flex-col gap-y-3">
    <FilevaliditySkeleton v-if="isLoading"></FilevaliditySkeleton>
    <template v-else>
      <!-- <fieldset class="border-2 border-primary rounded p-4 flex flex-col gap-y-5">
        <legend class="px-4 text-xl">{{ $t('fileValidity') }}</legend>
      </fieldset> -->

      <CollapsibleSection :header-label="$t('fileValidity')">
        <Form
          :initial-values="initialValues"
          :keep-values="true"
          class="flex flex-col gap-y-5"
          v-slot="{ errors, values, resetField, setFieldValue }"
          @submit="(values) => fileValidityStore.submitRequest(values)"
        >
          <FileValiditySelectors :errors :values :initial-values :reset-field :set-field-value />
          <CollapsibleSection body-class="flex flex-col gap-3">
            <component
              :is="values.selectIdentificater == 1 ? FileNumberForm : PassportForm"
              :errors
              :values
              :initial-values
              :reset-field
              :set-field-value
              class="w-full flex flex-col gap-y-2"
            />
          </CollapsibleSection>
          <GRecaptcha
            ref="gRecaptchaRef"
            class="flex justify-center"
            @successCallback="(args) => setFieldValue('recaptchaResponse', args)"
          ></GRecaptcha>
          <div class="flex justify-end">
            <button
              class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
            >
              <div class="p-2 bg-primary rounded-s-md">
                <faDiskette class="w-4 fill-white"></faDiskette>
              </div>
              <span class="w-full text-center">
                {{ $t('Save') }}
              </span>
              <div class="p-0.5"></div>
            </button>
          </div>
        </Form>
      </CollapsibleSection>

      <FileValidityResult v-if="Object.keys(fileValidityStore.result).length > 0" />
    </template>
  </div>
</template>

<script setup>
import faDiskette from '@/assets/icons/faDiskette.svg?component'
import GRecaptcha from '@/components/GRecaptcha/index.vue'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import { useFileValidityStore } from '@/stores/file_validity'
import FileNumberForm from '@/views/file-validity/_FileNumberForm.vue'
import FileValiditySelectors from '@/views/file-validity/_FileValiditySelectors.vue'
import PassportForm from '@/views/file-validity/_PassportForm.vue'
import FileValidityResult from '@/views/file-validity/FileValidityResult.vue'
import FilevaliditySkeleton from '@/views/file-validity/skeleton.vue'
import { Form } from 'vee-validate'
import { onMounted, ref } from 'vue'

const fileValidityStore = useFileValidityStore()

const isLoading = ref(true)

const initialValues = {
  selectIdentificater: 1,
  selectFileType: 1,
  fileModuleId: 1,
  selectFileIdentificater: 1
  // sample scenario
  // selectFileIdentificater: 2,
  // serviceYear: '2016',
  // sequenceNumber: '40318',
  // departmentCode: '201',
  // serviceCode: '7',
  // nationalityId: 24,
  // fileModuleId: 2,
  // dateOfBirth: '1979-01-01'
}
//#endregion

onMounted(async () => {
  await fileValidityStore.fetchCountries()
  isLoading.value = false
})
</script>

<style lang="scss" scoped></style>
